import React from 'react';
import BackgroundImage from '../components/BackgroundImage';

import styles from './Hero.module.scss';
import ScrollIndicator from '../components/ScrollIndicator';

const Hero = ({ image, children, className, light }) => {
  return (
    <BackgroundImage
      image={image}
      className={`${styles.container} ${className}`}
      light={light}
    >
      {children}
      <ScrollIndicator className={styles.indicator} />
    </BackgroundImage>
  );
};

export default Hero;
